import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import { Swiper } from "swiper/react";
import Color from "../../../assets/colors";

export const TitleStyled = styling(Typography)((props) => ({
  color: "rgba(0, 0, 0, 0.87)",
  fontSize: "25px",
  fontFamily: "Inter",
  fontWeight: 700,
  lineHeight: "32px",
  textAlign: "center",

  span: {
    color: Color.hiredlyPurple,
    fontSize: "40px",
    lineHeight: "32px",
    fontWeight: 400,
  },

  ...(props?.type == "subtitle" && {
    color: "rgba(0, 0, 0, 0.60)",
    fontFamily: "Inter",
    fontSize: "20px",
    lineHeight: "24px",
    fontWeight: 500,
    textAlign: "center",
  }),

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "25px",
    fontFamily: "Inter",
    fontWeight: 700,
    lineHeight: "32px",
    textAlign: "center",

    span: {
      color: Color.hiredlyPurple,
      fontSize: "32px",
      lineHeight: "32px",
      fontWeight: 400,
    },

    ...(props?.type == "subtitle" && {
      fontFamily: "Inter",
      fontSize: "16px",
      lineHeight: "24px",
      fontWeight: 500,
      textAlign: "center",
    }),
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "14px",
    fontFamily: "Inter",
    fontWeight: 700,
    lineHeight: "32px",
    textAlign: "left",

    span: {
      color: Color.hiredlyPurple,
      fontSize: "24px",
      lineHeight: "32px",
      fontWeight: 400,
    },

    ...(props?.type == "subtitle" && {
      fontFamily: "Inter",
      fontSize: "12px",
      lineHeight: "24px",
      fontWeight: 500,
      textAlign: "center",
    }),
  },
}));

export const SwiperStyled = styling(Swiper)((props) => ({
  width: "100%",
  overflow: "hidden",

  "& .swiper-wrapper": {
    transitionTimingFunction: "linear",
  },

  "& .swiper-slide": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "auto",
  },
}));

export const LogoContainer = styling(Grid)((props) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "150px",
  padding: "16px",
  minWidth: 0,
  cursor: "pointer",

  [props.theme.breakpoints.down("lg")]: {
    height: "100px",
    padding: "14px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    height: "80px",
    padding: "8px",
  },
}));

export const LogoStyled = styling("img")((props) => ({
  display: "block",
  width: "auto",
  height: "auto",
  maxWidth: "100%",
  maxHeight: "150px",
  objectFit: "contain",

  [props.theme.breakpoints.down("lg")]: {
    maxHeight: "80px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxHeight: "64px",
  },
}));

export const TitleContainer = styling(Grid)((props) => ({
  margin: "0px",

  [props.theme.breakpoints.down("tablet")]: {
    margin: "0px",
  },
}));

export const TrustedCompanyGrid = styling(Grid)((props) => ({
  padding: "40px 100px",
  gap: "32px",

  [props.theme.breakpoints.down("lg")]: {
    padding: "40px 24px",
    gap: "20px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "40px 16px",
    gap: "15px",
  },
}));

export const CarouselContainer = styling(Grid)((props) => ({
  height: "100%",
  maxWidth: "1240px",

  [props.theme.breakpoints.down("lg")]: {
    padding: "0px 0px",
  },
}));

export const CompanyButtons = styling("a")((props) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexShrink: 0,
  borderRadius: "16px",
  alignContent: "center",

  "&:hover": {
    border: "1px solid #512ACC",
  },
}));
